import { ItemQuestionario } from "src/app/questionario/questao/item-questionario-base";
import { TipoItemQuestionario } from "src/app/questionario/questao/model/tipo-item-questionario.enum";

export class QuestaoData extends ItemQuestionario<TipoItemQuestionario> {

  constructor(options: {} = {}) {
    super(options);
    this.questao.tipo = TipoItemQuestionario.DATA;
  }

  getLabel(): string {
    return 'Data';
  }

  getMaterialIcon(): string {
    return 'date_range';
  }

  isQuestaoEstruturada(): boolean {
    return false;
  }
}
